import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Card from '../../components/Card/Card';
import DataTable from '../../components/DataTable/DataTable';
import { IColInfo } from '../../components/DataTable/Interfaces';
import { useNotifications } from '../../contexts/notificationContext';
import DataService from "../../services/data.service";

const IncoTerms: React.FC = () => {
    const [data, setData] = useState<any[]>();
    const { handleException } = useNotifications();

    useEffect(() => {
        getTableData();
    }, []);

    function getTableData() {
        DataService.get<any[]>('api/v1/incoterms')
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    return (
        <>
            <div className='main-content'>
                <Container fluid>
                    <Row>
                        <Col md={12}>
                            <Card title='Inco terms'
                                content={
                                    <DataTable
                                        name='dtIncoTerms'
                                        tableData={data}
                                        colInfos={[
                                            { title: 'ID', key: true, dataProp: 'id', dataType: 'number' },
                                            { title: 'Code', dataProp: 'code', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
                                            { title: 'Name', dataProp: 'name', filterInfo: { filterType: 'Textbox' } },
                                        ]}
                                        navigateTitle='Inco term'
                                        navigateUrl='/plm/itemsetup/incoterm/'
                                    />
                                }
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}
export default IncoTerms;